import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServerErrorComponent } from './server-error/server-error.component';
import { DeleteComponent } from './delete/delete.component';
import { MaterialModule } from 'src/app/material.module';
import { TitleLineComponent } from './title-line/title-line.component';
import { DrawCreditComponent } from 'src/app/views/alunos/matricula-aluno/aluno-financeiro-contrato/matricula-caracteristicas-plano/cartao-credito/draw-credit/draw-credit.component';
import { PipeModule } from 'src/app/utils/pipes/pipe.module';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  declarations: [
    ServerErrorComponent,
    DeleteComponent,
    TitleLineComponent,
    DrawCreditComponent
  ],
  imports: [ CommonModule, MaterialModule, PipeModule, NgxMaskModule ],
  exports: [ ServerErrorComponent, TitleLineComponent, DrawCreditComponent ]
})
export class UtilsComponentModule { }
